import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { V_URL } from "../../../../../BaseUrl";
import toast from "react-hot-toast";
import axios from "axios";
import Footer from "../../../Include/Footer";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Loader from "../../../Include/Loader";
import { Pagination } from "../../../Table";
import moment from "moment";
import { getPurReceive } from "../../../../../Store/prosafe/proTransaction/PurReceive/getPurReceive";
import { Check, Slash, X } from "lucide-react";
import useModal from "../../../../../Components/CustomModal/useModal";
import AccRejModel from "./components/AccRejModel";
import PageHeader from "../../../Components/PageHeader/PageHeader";
import useDebounce from "../../../../../hooks/useDebounce";
import { getAdminItem } from "../../../../../Store/Store/Item/AdminItem";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getCategory } from "../../../../../Store/Store/StoreMaster/Category/Category";
import { getParty } from "../../../../../Store/Store/Party/Party";

const PurReceiveList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const modal = useModal();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);
  const [selectedItem, setSelectedItem] = useState(null);

  const [filter, setFilter] = useState({
    start_date: null,
    end_date: null,
    item_id: null,
    item_category_id: null,
    project_id: null,
    party_id: null,
  });

  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    dispatch(getAdminItem({ is_main: true }));
    dispatch(getProject());
    dispatch(getCategory());
    dispatch(getParty({ is_main: true }));
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [debouncedSearch, filter, currentPage, limit]);

  const fetchData = () => {
    const payload = {
      tag_number: 11,
      search: debouncedSearch,
      start_date: filter.start_date,
      end_date: filter.end_date,
      item_id: filter.item_id,
      item_category_id: filter.item_category_id,
      project_id: filter.project_id,
      party_id: filter.party_id,
      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
    }

    dispatch(getPurReceive({ formData: payload }));
  };

  const entity = useSelector((state) => state?.getPurReceive?.user?.data) || [];
  const isLoading = useSelector((state) => state?.getPurReceive?.loading);
  const itemData = useSelector((state) => state?.getAdminItem?.user?.data);
  const projectData = useSelector((state) => state?.getProject?.user?.data);
  const categoryData = useSelector((state) => state?.getCategory?.user?.data);
  const partyData = useSelector((state) => state.getParty?.user?.data) || [];

  const commentsData = useMemo(() => {
    let data = [...entity];
    setTimeout(() => setTotalItems(data.length), 0);
    return data.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit,
    );
  }, [entity, currentPage, limit]);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setCurrentPage(1);
  };

  const handleRefresh = () => {
    // fetchData();
    setFilter({
      start_date: null,
      end_date: null,
      item_id: null,
      item_category_id: null,
      project_id: null,
      party_id: null,
    });
  };

  const handleDelete = (id, title) => {
    Swal.fire({
      title: `Are you sure want to delete ${title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const myurl = `${V_URL}/prosafe/pro-delete-pu`;
        var bodyFormData = new URLSearchParams();
        bodyFormData.append("id", id);
        axios({
          method: "put",
          url: myurl,
          data: bodyFormData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        })
          .then((response) => {
            if (response.data.success === true) {
              toast.success(response?.data?.message);
              fetchData();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((error) => {
            toast.error(
              error?.response?.data?.message || "Something went wrong",
            );
          });
      }
    });
  };

  const handleDownload = async (id) => {
    try {
      const res = await axios.post(
        `${V_URL}/prosafe/download-preceiving-pdf/${id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        },
      );

      if (res?.data?.success === true) {
        window.open(res?.data?.data?.url);
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleDownloadExcel = async () => {
    try {
      const payload = {
        tag_number: 11,
        search: debouncedSearch,
        start_date: filter.start_date,
        end_date: filter.end_date,
        item_id: filter.item_id,
        item_category_id: filter.item_category_id,
        project_id: filter.project_id,
        party_id: filter.party_id,
        firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
        year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      };

      const res = await axios.post(
        `${V_URL}/prosafe/pro-pu-xlsx-download`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        }
      );

      if (res?.data) {
        window.open(res?.data?.data?.url);
        toast.success(res?.data?.message || "Excel downloaded successfully");
      } else {
        toast.error("Failed to download");
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || "Download failed");
    }
  };

  const breadCrumbs = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    { label: "Purchase Receiving" },
  ];

  const filterConfig = [
    {
      key: "item_id",
      label: "Item",
      type: "dropdown",
      value: filter.item_id,
      placeholder: "Select Item",
      searchable: true,
      options:
        itemData?.map((item) => ({ label: item.name, value: item._id })) || [],
    },
    {
      key: "item_category_id",
      label: "Item Category",
      type: "dropdown",
      value: filter.item_category_id,
      placeholder: "Select Item Category",
      searchable: true,
      options:
        categoryData?.map((category) => ({
          label: category.name,
          value: category._id,
        })) || [],
    },
    {
      key: "party_id",
      label: "Party",
      type: "dropdown",
      value: filter.party_id,
      placeholder: "Select Party",
      searchable: true,
      options:
        partyData?.map((party) => ({ label: party.name, value: party._id })) ||
        [],
    },
    {
      key: "project_id",
      label: "Project",
      type: "dropdown",
      value: filter.project_id,
      placeholder: "Select Project",
      searchable: true,
      options:
        projectData?.map((project) => ({
          label: `${project.name} (${project.project_no})`,
          value: project._id,
        })) || [],
    },
    {
      key: "start_date",
      label: "Start Date",
      type: "date",
      value: filter.start_date,
      placeholder: "Select Start Date",
    },
    {
      key: "end_date",
      label: "End Date",
      type: "date",
      value: filter.end_date,
      placeholder: "Select End Date",
    },
  ];



  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  <PageHeader
                    title="Purchase Receiving"
                    breadcrumbs={breadCrumbs}
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                    addButtonLink="/main-store/user/manage-purchase-receive"
                    onRefresh={handleRefresh}
                    filter={filter}
                    onFilterChange={handleFilterChange}
                    filterConfig={filterConfig}
                    limit={limit}
                    onLimitChange={(val) => setlimit(val)}
                    onDownload={handleDownloadExcel}
                  />

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card card-table show-entire">
                        <div className="card-body">
                          {!isLoading ? (
                            <div className="table-responsive">
                              <table className="table border-0 custom-table comman-table  mb-0">
                                <thead>
                                  <tr>
                                    <th>Sr.</th>
                                    <th>Date</th>
                                    <th>Receive No.</th>
                                    <th>Party</th>
                                    <th>Total Qty</th>
                                    <th>Total Amount (₹)</th>
                                    <th>Project</th>
                                    {/* <th>Project No</th> */}
                                    <th>Received By</th>
                                    {/* <th>Item Count</th> */}

                                    <th>Acc/Rej</th>
                                    <th className="text-end">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {commentsData?.map((elem, i) => (
                                    <tr key={elem?._id}>
                                      <td>
                                        {(currentPage - 1) * limit + i + 1}
                                      </td>
                                      <td>
                                        {elem.trans_date ? moment(elem.trans_date).format(
                                          "YYYY-MM-DD",
                                        ) : "-"}
                                      </td>
                                      <td>{elem.voucher_no}</td>
                                      <td>{elem?.party_data?.name || "-"}</td>
                                      <td>{elem.total_qty || 0}</td>
                                      <td>{elem.total_amount?.toFixed(2) || 0}</td>
                                      <td>
                                        {`${elem.project_data?.name} ${elem.project_data?.project_no
                                          ? `(${elem.project_data?.project_no})`
                                          : ""
                                          }` || "-"}
                                      </td>
                                      {/* <td>{elem?.project_data?.project_no || '-'}</td> */}
                                      {/* <td>{elem?.manual_pro_no || "-"}</td> */}
                                      <td>{elem?.received_by?.name || "-"}</td>
                                      {/* <td>{elem.item_count || 0}</td> */}
                                      <td>
                                        <span
                                          className="table-acc-rej"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Acc/Rej"
                                          onClick={() => {
                                            modal.show();
                                            setSelectedItem(elem?._id);
                                          }}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <Check />
                                          <X />
                                        </span>
                                      </td>
                                      <td className="text-end">
                                        <div className="dropdown dropdown-action">
                                          <a
                                            href="#"
                                            className="action-icon dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                            <i className="fa fa-ellipsis-v"></i>
                                          </a>
                                          <div className="dropdown-menu dropdown-menu-end">
                                            <button
                                              type="button"
                                              className="dropdown-item"
                                              onClick={() =>
                                                navigate(
                                                  `/main-store/user/view-purchase-receive`,
                                                  { state: elem },
                                                )
                                              }
                                            >
                                              <i className="fa-solid fa-eye m-r-5"></i>{" "}
                                              View
                                            </button>
                                            <button
                                              type="button"
                                              className="dropdown-item"
                                              onClick={() =>
                                                navigate(
                                                  `/main-store/user/manage-purchase-receive`,
                                                  { state: elem },
                                                )
                                              }
                                            >
                                              <i className="fa-solid fa-pen-to-square m-r-5"></i>{" "}
                                              Edit
                                            </button>
                                            <button
                                              type="button"
                                              className="dropdown-item"
                                              onClick={() =>
                                                handleDelete(
                                                  elem?._id,
                                                  elem.voucher_no,
                                                )
                                              }
                                            >
                                              <i className="fa fa-trash-alt m-r-5"></i>{" "}
                                              Delete
                                            </button>
                                            <button
                                              type="button"
                                              className="dropdown-item"
                                              onClick={() =>
                                                handleDownload(elem?._id)
                                              }
                                            >
                                              <i className="fa fa-download m-r-5"></i>{" "}
                                              Download
                                            </button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                  {commentsData?.length === 0 ? (
                                    <tr>
                                      <td colSpan="999">
                                        <div className="no-table-data">
                                          No Data Found!
                                        </div>
                                      </td>
                                    </tr>
                                  ) : null}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <Loader />
                          )}
                          <div className="row align-center mt-3 mb-2">
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                              <div
                                className="dataTables_info"
                                id="DataTables_Table_0_info"
                                role="status"
                                aria-live="polite"
                              >
                                Showing {Math.min(limit, totalItems)} from{" "}
                                {totalItems} data
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                              <div
                                className="dataTables_paginate paging_simple_numbers"
                                id="DataTables_Table_0_paginate"
                              >
                                <Pagination
                                  total={totalItems}
                                  itemsPerPage={limit}
                                  currentPage={currentPage}
                                  onPageChange={(page) => setCurrentPage(page)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <AccRejModel
        modal={modal}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </div>
  );
};

export default PurReceiveList;
